// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"4215d6ee","160":"21c07915","208":"5db68ec7","293":"26e5f3c0","453":"595bd2ed","516":"0c746f27","519":"4bed6451","713":"c0e3f5ca","917":"bdca39b3","946":"91f91e63"}[chunkId] + ".chunk.js";
};